import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=7bf467df&scoped=true&"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=7bf467df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf467df",
  null
  
)

export default component.exports